import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { SAPBetterServedDetails } from '../types/SAPVolumeBetterServed';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { DxDataGridComponent } from 'devextreme-angular';
import { saveAs } from 'file-saver';

@Component({
  selector: 'sap-volume-better-served',
  templateUrl: './sap-volume-better-served.component.html'
})
export class SAPVolumeBetterServedComponent implements OnInit {
  @ViewChild('sapVolumeBetterServedGrid', { static: true }) sapVolumeBetterServedGrid: DxDataGridComponent;
  _sapVolumeBetterServed: SAPBetterServedDetails[];
  @Input()
  set sapVolumeBetterServed(value: SAPBetterServedDetails[]) {
    this._sapVolumeBetterServed = value;
  }

  get sapVolumeBetterServed(): SAPBetterServedDetails[] {
    return this._sapVolumeBetterServed;
  }

  header1: string = 'Current Customers Better Served By Proposed Plant, All Segments';
  header2: string = '"Saved $/yr" use the trailer size and distributation cost entered in the top of the report';

  constructor() {

  }


  ngOnInit(): void {

  }

  exportExcel(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('SuspectList');
    exportDataGrid({
      component: this.sapVolumeBetterServedGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'SuspectList.xlsx');
        });
    });
    e.cancel = true;
  }

  getSumValueOnly(arg) {
    return arg.value.toFixed(2);
  }

  getCountValueOnly(arg) {
    return arg.value;
  }

  getDollerValueOnly(arg) {
    return "$" + arg.value;
  }

}